import React, { useEffect } from 'react';
import { PlayIcon, PauseIcon, SkipForwardIcon, RotateCcwIcon, XIcon } from 'lucide-react';
import { useDemoMode } from '../lib/demoMode';
import { motion, AnimatePresence } from 'framer-motion';
export function DemoController() {
  const {
    isActive,
    isPaused,
    currentStep,
    steps,
    startDemo,
    nextStep,
    previousStep,
    resetDemo,
    skipDemo,
    togglePause
  } = useDemoMode();
  // Auto-advance when not paused
  useEffect(() => {
    if (!isActive || isPaused) return;
    const currentStepData = steps[currentStep];
    if (!currentStepData) return;
    const timer = setTimeout(() => {
      nextStep();
    }, currentStepData.delayMs);
    return () => clearTimeout(timer);
  }, [isActive, isPaused, currentStep, steps, nextStep]);
  if (!isActive) return null;
  const progress = (currentStep + 1) / steps.length * 100;
  return <AnimatePresence data-id="element-560">
      <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} className="fixed bottom-6 right-6 z-[100]" data-demo="demo-controller" data-id="element-561">
        <div className="bg-slate-900 border border-slate-800 rounded-lg shadow-2xl overflow-hidden" data-id="element-562">
          {/* Progress Bar */}
          <div className="h-1 bg-slate-800" data-id="element-563">
            <motion.div className="h-full bg-blue-500" initial={{
            width: 0
          }} animate={{
            width: `${progress}%`
          }} transition={{
            duration: 0.3
          }} data-id="element-564" />
          </div>
          {/* Controller */}
          <div className="p-4 flex items-center gap-3" data-id="element-565">
            <div className="flex-1" data-id="element-566">
              <p className="text-xs text-slate-400 mb-1" data-id="element-567">
                Step {currentStep + 1} of {steps.length}
              </p>
              <p className="text-sm font-medium text-white" data-id="element-568">
                {steps[currentStep]?.title}
              </p>
            </div>
            <div className="flex items-center gap-2" data-id="element-569">
              <button onClick={togglePause} className="p-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors" title={isPaused ? 'Resume' : 'Pause'} data-id="element-570">
                {isPaused ? <PlayIcon className="w-4 h-4" data-id="element-571" /> : <PauseIcon className="w-4 h-4" data-id="element-572" />}
              </button>
              <button onClick={nextStep} className="p-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors" title="Next Step" data-id="element-573">
                <SkipForwardIcon className="w-4 h-4" data-id="element-574" />
              </button>
              <button onClick={resetDemo} className="p-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors" title="Reset Demo" data-id="element-575">
                <RotateCcwIcon className="w-4 h-4" data-id="element-576" />
              </button>
              <button onClick={skipDemo} className="p-2 bg-slate-800 hover:bg-slate-700 text-white rounded-lg transition-colors" title="Exit Demo" data-id="element-577">
                <XIcon className="w-4 h-4" data-id="element-578" />
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>;
}